<template>
  <RouterLink
    :to="to"
    class="qualification-item"
    :class="{ disabled: disabled }"
  >
    <FeatherIcon
      v-if="isUnverified"
      icon="circle"
      size="16"
      class="mr-2 text-yellow"
    />
    <FeatherIcon
      v-else-if="isRejected"
      icon="alert-circle"
      size="16"
      class="mr-2 text-red"
    />
    <FeatherIcon v-else icon="check-circle" size="16" class="mr-2 text-green" />

    <span class="text-primary-dark"><slot /></span>

    <span
      v-if="isUnverified"
      class="d-flex align-items-center ml-auto text-size-14 text-yellow"
      ><FeatherIcon icon="alert-circle" size="14" class="mr-1" />審査中</span
    >
    <span
      v-else-if="isRejected"
      class="d-flex align-items-center ml-auto text-size-14 text-red"
      ><FeatherIcon icon="alert-circle" size="14" class="mr-1" />差戻し</span
    >
  </RouterLink>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import verifiedStatus from "@/models/verifiedStatus";
import { RouteLocationRaw } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class QualificationItem extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  status!: string;

  @Prop({
    type: Object,
    default: () => ({})
  })
  to!: RouteLocationRaw;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  disabled!: boolean;

  get isUnverified() {
    return this.status === verifiedStatus.UNVERIFIED;
  }
  get isRejected() {
    return this.status === verifiedStatus.REJECTED;
  }
}
</script>

<style lang="scss" scoped>
.qualification-item {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: $white;
  border: 1px solid $gray-04;
  border-radius: 4px;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
